import React from 'react';
import { useStore } from 'Hooks/useStore';

export function Logo({ className = '', url = null, isVariant = false, width, height }) {
  const { siteLogo = {} } = useStore('appConfig.pageMeta');
  const { path, variant, alt, title } = siteLogo;
  const defaultLogo = isVariant ? variant : path;
  return <img className={className} src={url || defaultLogo} alt={alt} title={title} width={width} height={height} />;
}
